<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!dpaFile">
      <span class="loader"></span>
    </span>
    <dpa-file-form
      v-if="dpaFile"
      :loading="loading"
      :dpaFileData="dpaFile"
      :formErrors="formErrors"
      @dpaFileSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import DpaFileForm from "../partials/DpaFileForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { DpaFileForm },

  mixins: [alertLeave],

  props: {
    dpaFileId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      dpaFile: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("dpaFiles/get", this.dpaFileId);
        this.dpaFile = this.$store.getters["dpaFiles/dpaFile"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(dpaFile) {
      this.loading = true;
      const dpaFileData = cloneDeep(dpaFile);

      try {
        await this.$store.dispatch("dpaFiles/update", dpaFileData);
        this.$notify({
          type: "success",
          message: this.$t("DPA_PPA.FILE_UPDATED"),
        });
        const dpaFile = await this.$store.getters["dpaFiles/dpaFile"];
        this.$emit("onViewDpaFile", dpaFile, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
